import type { useAssetJobsStatusFragment } from '../../shared/gql/generated/AssetJobsStatus';
import type { AssetState } from '../types';

export function getStateForAssetJob(
  assetJobsFragment: ReturnType<typeof useAssetJobsStatusFragment>
): AssetState | undefined {
  return assetJobsFragment?.data?.assetJobs?.some(
    (job) => job?.__typename === 'BrandValidationAssetJob'
  )
    ? 'validating-brand'
    : undefined;
}
